<div style="display: block;" style="overflow: auto; height: 350px;">
  <div style="display: block;">
    <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
      [colors]="barChartColors" [plugins]="barChartPlugins" [legend]="barChartLegend" [chartType]="barChartType"
      height="350">
    </canvas>
  </div>
</div>

<form [formGroup]="chartForm" (ngSubmit)="onSubmit()">
  <div class="" style="display: flex;
  justify-content: space-between; margin-top: 20px;">
    <!-- <label class="content-row-label">{{ 'label.beginDate' | translate}}</label> -->
    <mat-form-field class="" style="margin: 5px;">
      <input matInput [matDatepicker]="startDateContract" formControlName="dateBegin" autocomplete="off"
        [max]="chartForm.get('dateEnd')?.value" placeholder="{{ 'label.beginDate' | translate}}">
      <mat-datepicker-toggle matSuffix [for]="startDateContract"></mat-datepicker-toggle>
      <mat-datepicker #startDateContract [disabled]="chartForm.get('dateBegin')?.disabled"></mat-datepicker>
    </mat-form-field>
    <!-- <label class="content-row-label">{{ 'label.endDate' | translate}}</label> -->
    <mat-form-field class="" style="margin: 5px;">
      <input matInput [matDatepicker]="endDateContract" formControlName="dateEnd" autocomplete="off"
        [min]="chartForm.get('dateBegin')?.value" placeholder="{{ 'label.endDate' | translate}}">
      <mat-datepicker-toggle matSuffix [for]="endDateContract"></mat-datepicker-toggle>
      <mat-datepicker #endDateContract [disabled]="chartForm.get('dateEnd')?.disabled"></mat-datepicker>
    </mat-form-field>
  </div>
</form>